import disclosureDocuments from '../legacy/organisms/disclosure-documents/disclosure-documents';
import disclosuresSearch from '../legacy/organisms/disclosures-search-form/disclosures-search-form';

import '../legacy/organisms/disclosure-documents/_disclosure-documents.scss';
import '../legacy/organisms/disclosures-search-form/_disclosures-search-form.scss';

function onLoad() {
  disclosureDocuments.init();
  disclosuresSearch.init();
}

if (document.readyState === 'complete') {
  onLoad();
} else {
  window.addEventListener('load', onLoad, { once: true });
}
